var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:(_vm.css),attrs:{"src":_vm.logo,"alt":"Logo Oasis"}})])}
var staticRenderFns = []

export { render, staticRenderFns }